import { sortBy } from '@debbie/common/dist/economy/helpers/utils.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useUpdateTypes } from '@debbie/cortex/dist/update-types/index.js';
import moment from 'moment';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { Panel } from '../index.js';
import UpdateTypeSelect from '../UpdateTypeSelect.js';
import UpdateType from './UpdateType.js';
const onDragStart = (event, updateType) => {
    event.dataTransfer.setData('application/reactflow', JSON.stringify(updateType));
    event.dataTransfer.effectAllowed = 'move';
};
const AddUpdate = (props) => {
    const updateTypesLoadable = useUpdateTypes();
    const updateTypes = h.hasData(updateTypesLoadable)
        ? updateTypesLoadable.data
        : null;
    const lang = useSelector((s) => s.lang);
    const sortedUpdateTypes = useMemo(() => {
        return (updateTypes &&
            updateTypes.slice().sort(sortBy((a, b) => isNew(a) - isNew(b), (a, b) => (b.procedureEnabled ? 1 : 0) - (a.procedureEnabled ? 1 : 0), (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())));
    }, [updateTypes]);
    return (React.createElement(AddUpdatePanel, null,
        React.createElement(UpdateTypeSelect, { value: null, onChange: (updateTypeId) => {
                if (updateTypeId != null) {
                    props.onAddUpdateType(updateTypeId);
                }
            }, placeholder: lang.procedures.addTask }),
        sortedUpdateTypes && (React.createElement(UpdateTypesList, null,
            sortedUpdateTypes.length === 0 && (React.createElement("h3", null, lang.workflows.noUpdatesToShow)),
            sortedUpdateTypes.map((updateType) => {
                return (React.createElement(UpdateBox, { key: updateType.updateTypeId, onDragStart: (event) => onDragStart(event, updateType), draggable: true },
                    React.createElement(UpdateType, { updateType: updateType, workflowId: props.workflowId })));
            })))));
};
export default AddUpdate;
const UpdateBox = styled.div `
  border: 1px solid #ccc;
  padding: 10px 20px;
  border-radius: 3px;
  margin-bottom: 10px;
  cursor: grab;
`;
const BASE_HEIGHT = 340;
const UpdateTypesList = styled.div `
  overflow-y: scroll;
  max-height: calc(100vh - ${BASE_HEIGHT + 136}px);
`;
const AddUpdatePanel = styled(Panel) `
  position: absolute;
  width: 300px;
  z-index: 9;
  right: 40px;
  top: 80px;

  .body {
    max-height: calc(100vh - ${BASE_HEIGHT}px);
  }
`;
const isNew = (updateType) => {
    if (moment(updateType.createdAt).isAfter(moment().subtract(1, 'day'))) {
        return 1;
    }
    return 2;
};
//# sourceMappingURL=AddUpdate.js.map